<template>
	<div class="route-view">
		<tabs-view class="-side-window" :active="tab" @input="stopSelect" name="type" :tabs="_tabs" />
		<div class="address">
			Adresse
			<div class="buttons">
				<div @click="mirror()">Spejlvend rute</div>
				<div @click="remove(parseInt(tab))">Fjern stop</div>
			</div>
		</div>
		<address-view :contact_id="contact_id" v-model="value[_index]" />
		<div>Egenskaber på adressen</div>
		<div class="side-window__heading small">
			Elevator
			<switch-view v-model="value[_index].elevator" />
		</div>
		<div class="side-window__heading small">
			Møbellift
			<switch-view v-model="value[_index].lift" />
		</div>
		<string-view v-model="value[_index].distance" label="Meter til bil" :optional="true" />
		<string-view v-model="value[_index].floors" label="Etager" :optional="true" />
		<div>Instruktioner på adressen</div>
		<instructions-view v-model="value[_index].instructions" />
	</div>
</template>

<script>
	import AddressView from '../views/AddressView'
	//import RequirementsView from '../views/RequirementsView'
	import InstructionsView from '../views/InstructionsView'
	//import PackagingView from '../views/PackagingView'

	import merge from '../functions/merge'

	const stop = {
		address: '',
		zip: '',
		city: '',
		country: '',
		//duration: 60,
		instructions: {},
		elevator: false,
		lift: false,
		distance: ''
		//requirements: [],
		//packaging: [],
		//driving: 30
	};

	export default {
		components: {
			'AddressView': AddressView,
		//	'RequirementsView': RequirementsView,
			'InstructionsView': InstructionsView,
		//	'PackagingView': PackagingView
		},
		data() {
			return {
				tab: '0'
			};
		},
		props: {
			contact_id: {
				type: Number,
				default: null
			},
			value: {
				type: Array,
				default: function () {
					return [
						Object.assign({}, stop),
						Object.assign({}, stop)
					];
				}
			}
		},
		watch: {
			value() {
				this.normalizeValue();
			}
		},
		computed: {
			_index() {
				return Math.round(parseInt(this.tab) / 2);
			},
			_tabs() {
				var r = [];
				var j = 0;

				for (var i = 0; i < this.value.length; ++i) {
					if (i == 0) {
						r.push({
							label: 'Fra',
							name: j.toString()
						});
					} else if (i + 1 == this.value.length) {
						r.push({
							label: 'Til',
							name: j.toString()
						});
					} else {
						r.push({
							label: 'Via',
							name: j.toString()
						});
					}

					++j;

					if (i == 0 || i + 1 < this.value.length) {
						r.push({
							label: '+',
							name: j.toString()
						});

						++j;
					}
				}

				return r;
			}
		},
		methods: {
			normalizeValue() {
				if (this.value.length == 0) {
					this.$emit('input', [
						Object.assign({}, stop),
						Object.assign({}, stop)
					]);
				}

				if (this.value.length == 1) {
					var value = [merge(stop, this.value[0])];
					value.push(Object.assign({}, stop));
					this.$emit('input', value);
				}
			},
			stopSelect(name, tabName) {
				

				if (parseInt(tabName) % 2 == 1) {
					var value = Array.from(this.value);
					value.splice(Math.round(parseInt(tabName) / 2), 0, Object.assign({}, stop));
					this.$emit('input', value);
					this.tab = (parseInt(tabName) + 1).toString();
				} else {
					this.tab = tabName;
				}
			},
			remove(pos) {
				

				var i = Math.round(pos / 2);
				var value = Array.from(this.value);
				
				value.splice(i, 1);

				this.tab = '0';

				this.$emit('input', value);
			},
			mirror() {
				
				var value = Array.from(this.value);
				this.$emit('input', value.reverse());				
			}
		},
		created() {
			this.normalizeValue();
		}
	}
</script>

<style lang="scss" scoped>
	.route-view {
		& > .address {
			position: relative;

			& > .buttons {
				position: absolute;
				top: 0;
				right: 5px;

				& > div {
					margin-left: 15px;
					font-size: 12px;
					cursor: pointer;
					white-space: nowrap;
					display: inline-block;
				}
			}
		}
	}
</style>